import { FC, useState } from 'react'
import { useCookies } from 'react-cookie'
import { addDays } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import { TIMEZONE } from 'utils/config'

interface IFCoverLetterWriteTooltipProps {}

const COVER_LETTER_WRITE_TOOLTIP_COOKIE_NAME = 'lnkr_cover_letter_write_tooltip'

const CoverLetterWriteTooltip: FC<IFCoverLetterWriteTooltipProps> = ({
  children,
}) => {
  const [cookies, setCookie] = useCookies()
  const [openTooltip, setOpenTooltip] = useState<boolean>(
    !cookies?.[COVER_LETTER_WRITE_TOOLTIP_COOKIE_NAME],
  )
  const isMobile = useIsMobile()

  const getCookieDomain = () => {
    const url = window.location.href
    if (url.includes('linkareer')) return '.linkareer.com'
    if (url.includes('lnkr')) return '.lnkr.cc'
    return 'localhost'
  }

  const handleSetCookie = (expiresDate: Date) => {
    setCookie(COVER_LETTER_WRITE_TOOLTIP_COOKIE_NAME, Date.now(), {
      expires: expiresDate,
      domain: getCookieDomain(),
      path: '/',
    })
  }

  const handleNoViewingForWeek = () => {
    const after7Days = zonedTimeToUtc(addDays(new Date(), 7), TIMEZONE)
    handleSetCookie(after7Days)
    setOpenTooltip(false)
  }

  return (
    <StyledWrapper>
      {children}
      {!isMobile && openTooltip && (
        <div className="tooltip">
          보고있는 합격자소서 참고해서 내 자소서 작성하기
          <i onClick={handleNoViewingForWeek}>
            <Close />
          </i>
        </div>
      )}
    </StyledWrapper>
  )
}

export default CoverLetterWriteTooltip

const StyledWrapper = styled.div`
  position: relative;
  > .tooltip {
    top: calc(100% + 15px);
    display: flex;
    align-items: center;
    position: absolute;
    min-width: max-content;
    padding: 15px;
    background-color: #2a22fc;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.64px;
    color: #fff;
    gap: 10px;

    > i > svg {
      display: block;
      width: 16px;
      height: 16px;
      cursor: pointer;
      fill: #fff;
    }

    &::before {
      border-color: #2a22fc transparent;
      border-style: solid;
      border-width: 0 6px 8px 6.5px;
      margin-left: -5px;
      content: '';
      display: block;
      left: 5%;
      position: absolute;
      top: -8px;
      width: 0;
      z-index: 0;
    }
  }
`
